module.exports = __webpack_public_path__ + "media/images/category_icons/books-9bdd88562148a05e9134dc7c6f5c34bc.svg";